import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getInspectionsSummary } from '@/selectors';

export type InspectionsSummary = {
    critical: number;
    failed: number;
    overdue: number;
    withoutIssues: number;
};

type OverviewTileProps = {
    footer?: string;
    icon: string;
    label: string;
    value?: number;
    valueClassName: string;
};

const OverviewTile = ({ footer, icon, label, value, valueClassName }: OverviewTileProps) => (
    <StatsWidget className='shadow-default display-flex flex-column'>
        <div className='display-flex flex-column flex-1-1'>
            <div className='flex-1-1 display-flex gap-15 padding-20'>
                <div className='height-50 aspect-ratio-1 bg-lightest rounded display-grid place-items-center text-size-14'>
                    <span className={`uikit-icon ${icon} text-size-20 ${valueClassName}`} aria-hidden='true' />
                </div>
                <div>
                    <div className='text-color-dark'>{label}</div>
                    <div className='text-size-h3 text-color-darkest line-height-125rel'>{value ?? '-'}</div>
                </div>
            </div>
            {footer && (
                <div className='text-size-12 padding-x-20 padding-y-10 bg-lightest rounded-bottom display-flex gap-5'>
                    <span className='text-color-dark'>{footer}</span>
                </div>
            )}
        </div>
    </StatsWidget>
);

const PDCOverviewTiles = () => {
    const { formatMessage } = useIntl();
    const summary: InspectionsSummary | null | undefined = useSelector(getInspectionsSummary);

    return (
        <StatsWidgets className='display-grid grid-auto-fit-250 margin-bottom-20'>
            <OverviewTile
                icon='icon-error-sign'
                label={formatMessage({ id: 'intl-msg:pdc.overview.critical.label' })}
                value={summary?.critical}
                valueClassName='text-color-danger'
                footer={formatMessage({ id: 'intl-msg:pdc.overview.critical.footer' })}
            />
            <OverviewTile
                icon='icon-warning-sign'
                label={formatMessage({ id: 'intl-msg:pdc.overview.failed.label' })}
                value={summary?.failed}
                valueClassName='text-color-warning'
                footer={formatMessage({ id: 'intl-msg:pdc.overview.failed.footer' })}
            />
            <OverviewTile
                icon='icon-time'
                label={formatMessage({ id: 'intl-msg:pdc.overview.overdue.label' })}
                value={summary?.overdue}
                valueClassName='text-color-warning'
                footer={formatMessage({ id: 'intl-msg:pdc.overview.overdue.footer' })}
            />
            <OverviewTile
                icon='icon-check-badge'
                label={formatMessage({ id: 'intl-msg:pdc.overview.withoutIssues.label' })}
                value={summary?.withoutIssues}
                valueClassName='text-color-success'
                footer={formatMessage({ id: 'intl-msg:pdc.overview.withoutIssues.footer' })}
            />
        </StatsWidgets>
    );
};

export default PDCOverviewTiles;
